
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shorts/[[...slug]]",
      function () {
        return require("private-next-pages/shorts/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shorts/[[...slug]]"])
      });
    }
  